module.exports = __webpack_public_path__ + "img/BMG_Stabalizing_Fracture.658c223b.jpg";